// extracted by mini-css-extract-plugin
export default {"deleteBtn":"remove-reg-item-action__deleteBtn__e5JAE"};